module.exports = __webpack_public_path__ + "img/app.ab9f7378.svg";